import { useContext } from 'react';
import { VehicleSearchContext } from '../providers/VehicleSearchProvider';

export const useVehicleSearchContext = () => {
    const context = useContext(VehicleSearchContext);
    if (!context) {
        throw new Error('useVehicleSearchContext must be used within VehicleSearchProvider');
    }
    return context;
};
